// eslint-disable-next-line import/no-anonymous-default-export
export default {
  company: {
    introduce: {
      community: {
        title: "Community Edition Users Management",
        description:
          "Community Edition Users Management is used to manage and view all cloud Extended Community Edition user information.",
      },
      enterprise: {
        title: "Enterprise Edition Users Management",

        description:
          "Enterprise Edition Users Management is used to manage and create enterprise users, and manage the system configurations of a single user.",
      },
    },
    companyId: "Company ID",
    companyName: "Company Name",
    companyType: "Company Type",
    companyInfo: "Company Information",
    companySize: "Company Size",
    companyEmail: "Company Email",
    AccountSetting: "Account Settings",
    isFixedPostfixMailbox:
      "Specifies whether to restrict user accounts to fixed email addresses",
    mailboxPostfixConfiguration: "Mailbox Suffix Configuration",
    addSuffix: "Add the suffix",
    addSuffixTip: "Click the Add button to add the suffix",
    initializeAdministratorAccount: "Initial Administrator account",
    initializeAdministratorPassword: "Initial administrator password",
    updatePasswordTips:
      "Leaving the item as an empty commit means that no changes are made to the item",
    licenseDetail: "License Detail",
    licenseNumber: "License Number",
    renewContract: "Renew Contract",
    renewContractSuccessfully: "Renew contract successfully",
    setting: {
      name: "Basic information",
      title: "Basic User Information",
      customerIdentifier: "Company ID (Identification code)",
    },
    validate: {
      stringLength: "{name}must be between {min}-{max} characters",
      inputCompanyName: "Please enter the company name",
      inputPrefix: "Please enter the mailbox prefix",
      inputSuffix: "Please enter the email suffix",
      prefixErr: "The format of the mailbox prefix is incorrect",
      suffixErr: "The email suffix format is incorrect",
      selectSuffix: "Please select a mailbox suffix",
      emailSuffixRepeat: "Duplicate mailbox suffix",
      addEmailSuffix: "Please add mailbox suffix",
      inputPassword: "Please enter a password",
      inputCompanyType: "Please enter the company type",
    },
  },
};
